import React, { useState, useEffect } from "react";
import SpinningLoader from "@src/components/common/SpinningLoader/SpinningLoader";
import { Link, useSearchParams } from "react-router-dom";
import Tile from "@src/components/containers/Tile";
import { useToast } from "@swordsweeper/ssi-ui-component-library";
import * as CovetrusApi from "@src/api/CovetrusApi";
import { extractServerErrorMessage } from "@src/utils/error";

function CovetrusAuthCallbackPage(): React.JSX.Element {
  const { showToast } = useToast();
  const [isSavingAuthToken, setIsSavingAuthToken] = useState<boolean>(false);
  const [isSuccessfullyConnected, setIsSuccessfullyConnected] =
    useState<boolean>(false);
  const [responseMessage, setResponseMessage] = useState<string | null>(null);
  const [searchParams] = useSearchParams();
  const code = searchParams.get("code");
  const state = searchParams.get("state");

  useEffect(() => {
    if (!code) return;

    const exchangeCodeForTokens = async () => {
      setIsSavingAuthToken(true);
      try {
        const response = await CovetrusApi.validateOAuthCode(code, state);
        setResponseMessage("Successfully connected to Covetrus!");

        showToast({
          message: "Successfully connected to Covetrus",
          variant: "success",
        });
        setIsSuccessfullyConnected(true);
      } catch (err: any) {
        console.error("Token exchange error:", err);

        const errorObj = err as any;
        const responseBody = errorObj?.response?.body;

        const serverErrorMessage = extractServerErrorMessage(responseBody);

        showToast({
          message: serverErrorMessage,
          variant: "error",
        });

        setResponseMessage(serverErrorMessage);
      } finally {
        setIsSavingAuthToken(false);
      }
    };

    exchangeCodeForTokens();
  }, [code, state]);

  return (
    <>
      {isSavingAuthToken && <SpinningLoader />}
      <div className="flex-row flex-center">
        <Tile className="width-50 text-center">
          {!responseMessage && <h4>Saving...</h4>}

          {responseMessage && (
            <h4
              className={
                isSuccessfullyConnected ? "text-success" : "text-error"
              }
            >
              {!isSuccessfullyConnected && "Error connecting to Covetrus: "}
              {responseMessage}
            </h4>
          )}

          <Link to="/account/distributors" className="text-sm margin-top-md">
            Back to Distributors
          </Link>
        </Tile>
      </div>
    </>
  );
}

export default CovetrusAuthCallbackPage;
